import React, { useContext, useEffect } from 'react';
import { AppContext } from 'App.context';
import CustomButton from 'Components/common/CustomButton/CustomButton';
import Loading from 'Components/common/Loader/Loading';
import Colors from 'constants/Colors';
import usePmsConfigHook from './PMSConfig.hook';
import styles from './PMSConfig.styles';
import ConfigurationForm from 'Components/common/ConfigurationForm/ConfigurationForm';
import AutomaticConfigurationTest from 'Components/common/ConfigurationForm/AutomaticConfigurationTest/AutomaticConfigurationTest';
import getPMSLogo from 'utils/getPMSLogo';
import AutomaticBookingTest from 'Components/common/ConfigurationForm/AutomaticBookingTest/AutomaticBookingTest';
import SelectOB from 'Components/Dashboard/Onboarding/Selector/Selector';
import PMSUDFConfig from 'Components/Dashboard/PMS/PMSUDFConfig/PMSUDFConfig';
import { Col, Row } from 'antd';

const PMSsWithCustomUDFConfig = ['Ohip', 'OhipDynamic', 'Ohip_new', 'Opera', 'Opera_new'];

export default function PMSConfig({ rowData, selectedPms, setPmsCheckin, pmsList, hotelPms }) {
  const { state, actions } = usePmsConfigHook(setPmsCheckin, rowData, hotelPms);
  const {
    appState: { currentLanguage },
    appActions: { translate },
  } = useContext(AppContext);

  useEffect(() => {
    actions.loadPmsConfig(selectedPms, rowData.id);
  }, [selectedPms]);
  const literals =
    selectedPms?.name?.toLowerCase() in currentLanguage.pmsConfig
      ? currentLanguage.pmsConfig[selectedPms?.name?.toLowerCase()]
      : null;

  const pmsSuscribed = pmsList.find(pms => pms.id == rowData.pmsIdSuscribed)?.name;
  const healthCheckConnectionEnabled =
    (pmsSuscribed || rowData.pmsCheckin != 'NoIntegration') &&
    selectedPms.healthCheckConnection === 1;
  const healthCheckBookingEnabled =
    (pmsSuscribed || rowData.pmsCheckin != 'NoIntegration') && selectedPms.configBookingSearchForm;
  const PMSUDFCustom = PMSsWithCustomUDFConfig.includes(rowData.pmsCheckin);

  const pmsTranslation = selectedPms?.name
    ? translate(`pmsName.${selectedPms?.name.toLowerCase()}`)
    : '';
  const pmsName = pmsTranslation.includes('.') ? selectedPms?.name : pmsTranslation;
  const showForm = selectedPms.connectionType === 'form' && literals;

  return !state.isLoading ? (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={styles.header}>
          <img style={styles.icon} src={getPMSLogo(selectedPms?.name)} alt="PMS Logo" />
          <div style={styles.title}>{pmsName}</div>
        </div>

        <div style={{ width: 48 }} />
        {showForm && (
          <div style={{ display: 'flex', gap: 8, flexDirection: 'column', flex: 1 }}>
            {Object.keys(state.orderedConfig)
              ?.filter(fieldCategory => fieldCategory !== 'configFilesCheckboxesAllowed')
              ?.map((fieldCategory, index) => {
                return (
                  <div key={index}>
                    <div style={styles.category}>{translate(`pmsCategory.${fieldCategory}`)}</div>
                    <ConfigurationForm
                      fields={state.orderedConfig[fieldCategory]}
                      literals={literals}
                      getFieldValue={actions.getFieldValue}
                      onValueChanged={actions.onValueChanged}
                    />
                  </div>
                );
              })}
            {state.orderedConfig['configFilesCheckboxesAllowed']?.length > 0 && (
              <Row justify="space-between" align={'middle'}>
                <Col style={{ display: 'flex', alignItems: 'end' }}>
                  <span style={styles.smallText}>{translate('pmsFeature.pmsFeatures')}</span>
                </Col>

                {state.orderedConfig['configFilesCheckboxesAllowed']?.map((feature, index) => (
                  <Col key={index}>
                    <span style={styles.smallText}>
                      {translate(`pmsFeature.${feature.key}`)} -{' '}
                      {translate(`pmsFeature.${feature.value}`)}
                    </span>
                  </Col>
                ))}
              </Row>
            )}

            {
              <div style={{ justifyContent: 'right', display: 'flex' }}>
                <CustomButton
                  style={styles.button}
                  background={Colors.primaryGreen}
                  color={'white'}
                  text={translate('save')}
                  onClick={() => actions.onSave(selectedPms, rowData.id, rowData.pmsCheckin)}
                />
              </div>
            }

            {PMSUDFCustom && <PMSUDFConfig selectedPms={selectedPms} />}
          </div>
        )}
      </div>
      {healthCheckConnectionEnabled && (
        <>
          <AutomaticConfigurationTest
            hotelId={rowData.id}
            buttonAction={async () => {
              actions.onSave(selectedPms, rowData.id, rowData.pmsCheckin);
              await actions.doAutomaticTest(rowData.id);
            }}
          />
        </>
      )}

      {healthCheckBookingEnabled && (
        <SelectOB hotelId={rowData.id} actions={actions} selectedPms={selectedPms} />
      )}
    </div>
  ) : (
    <div style={styles.loadingContainer}>
      <Loading />
    </div>
  );
}
